<template>
  <div class="text-sm font-medium text-text-secondary truncate">{{ name }}</div>
</template>

<script>
export default {
  name: "AccountName",
  props: {
    name: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>